// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaveCalendar-errorMessage-gKG3f {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}
.SaveCalendar-space1-tD9QG {
	margin-bottom: 6px !important;
}
.SaveCalendar-space2-EyXsY {
	margin-bottom: 12px !important;
}
.SaveCalendar-space3-d4EYA {
	margin-bottom: 18px !important;
}
.SaveCalendar-space4-z9fue {
	margin-bottom: 24px !important;
}
.SaveCalendar-space5-l9CPK {
	margin-bottom: 30px !important;
}
.SaveCalendar-space6-ulQEm {
	margin-bottom: 36px !important;
}
.SaveCalendar-space7-tgDI9 {
	margin-bottom: 42px !important;
}
.SaveCalendar-space8-n6Ix3 {
	margin-bottom: 48px !important;
}
.SaveCalendar-spaceTop1-c9EzL {
	margin-top: 6px !important;
}
.SaveCalendar-spaceTop2-cosGs {
	margin-top: 12px !important;
}
.SaveCalendar-spaceTop3-n3jRv {
	margin-top: 18px !important;
}
.SaveCalendar-spaceTop4-k0Qgg {
	margin-top: 24px !important;
}
.SaveCalendar-spaceTop5-diYPC {
	margin-top: 30px !important;
}
.SaveCalendar-spaceTop6-vWoAo {
	margin-top: 36px !important;
}
.SaveCalendar-spaceTop7-xFwZW {
	margin-top: 42px !important;
}
.SaveCalendar-spaceTop8-WpJKF {
	margin-top: 48px !important;
}
.SaveCalendar-noMargin-y6Pe7 {
	margin: 0px !important;
}
.SaveCalendar-padding1-H5qkr {
	padding-bottom: 6px !important;
}
.SaveCalendar-padding2-JIhcD {
	padding-bottom: 12px !important;
}
.SaveCalendar-padding3-w8VYr {
	padding-bottom: 18px !important;
}
.SaveCalendar-padding4-Cad9j {
	padding-bottom: 24px !important;
}
.SaveCalendar-padding5-fH28s {
	padding-bottom: 30px !important;
}
.SaveCalendar-padding6-vIgKg {
	padding-bottom: 36px !important;
}
.SaveCalendar-padding7-pGled {
	padding-bottom: 42px !important;
}
.SaveCalendar-paddingTop1-oAaEI {
	padding-top: 6px !important;
}
.SaveCalendar-paddingTop2-hqyKk {
	padding-top: 12px !important;
}
.SaveCalendar-paddingTop3-M6Pqm {
	padding-top: 18px !important;
}
.SaveCalendar-paddingTop4-CvtpU {
	padding-top: 24px !important;
}
.SaveCalendar-paddingTop5-tR2fT {
	padding-top: 30px !important;
}
.SaveCalendar-paddingTop6-FbF5b {
	padding-top: 36px !important;
}
.SaveCalendar-paddingTop7-B2RWU {
	padding-top: 42px !important;
}
.SaveCalendar-noPadding-nt7Pt {
	padding: 0px !important;
}
.SaveCalendar-spaceMarginBottom0-YZ0Mw {
	margin-bottom: 0;
}
.SaveCalendar-textBold-Pdw2_ {
	font-weight: 500 !important;
}
.SaveCalendar-textBolder-N1aIw {
	font-weight: 700 !important;
}
.SaveCalendar-textNormal-TB4OB {
	font-weight: normal !important;
}
/*New Design Text Colors */
.SaveCalendar-textDarkBlue-mcQhN {
	color: rgb(20, 39, 94) !important;
}
.SaveCalendar-textLightBlue-ZFVM8 {
	color: rgb(57, 87, 106) !important;
}
.SaveCalendar-textLightSandleGreen-mjtY4 {
	color: rgb(76, 86, 41) !important;
}
.SaveCalendar-textLightBrown-AoxRY {
	color: rgb(115, 79, 33) !important;
}
.SaveCalendar-textMediumMaroon-F8zRS {
	color: rgb(87, 37, 51) !important;
}
.SaveCalendar-textBrown-A4_v4 {
	color: rgb(160, 47, 24) !important;
}
.SaveCalendar-textMaroon-ifcnX {
	color: rgb(155, 49, 67) !important;
}
.SaveCalendar-textDarkBrown-PxfPQ {
	color: rgb(83, 18, 16) !important;
}
.SaveCalendar-textMediumBrown-_CZB1 {
	color: rgb(142, 28, 10) !important;
}
.SaveCalendar-textSkyBlue-Mu6P8 {
	color: rgb(37, 117, 141) !important;
}
.SaveCalendar-textGray-qsq4b {
	color: rgb(77, 65, 51) !important;
}
.SaveCalendar-btn-cqi6K,
.SaveCalendar-btn-cqi6K:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 8px 12px 8px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 6px !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.SaveCalendar-btn-cqi6K:hover {
	background: var(--common-background-color) !important;
	outline: 0 !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.SaveCalendar-btn-cqi6K:hover img {
	-webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
	        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
}
.SaveCalendar-btnPrimary-k8x4j,
.SaveCalendar-btnPrimary-k8x4j:focus {
	border-color: var(--btn-primary-bg) !important;
	background-color: var(--btn-primary-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.SaveCalendar-btnPrimary-k8x4j:hover {
	border-color: var(--btn-primary-bg-hover) !important;
	background-color: var(--btn-primary-bg-hover) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.SaveCalendar-btnPrimaryBorder-g29N9,
.SaveCalendar-btnPrimaryBorder-g29N9:focus {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	border-radius: 6px;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
}
.SaveCalendar-btnPrimaryBorder-g29N9:hover {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	text-decoration: none !important;
	font-weight: 500;
}
.SaveCalendar-btnSecondary-t8jqD,
.SaveCalendar-btnSecondary-t8jqD:focus {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-bg) !important;
	color: var(--white-text) !important;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	white-space: pre-line;
}
.SaveCalendar-btnSecondary-t8jqD:hover {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-hover-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.SaveCalendar-btnLink-cFIw7,
.SaveCalendar-btnLink-cFIw7:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	width: auto !important;
	outline: 0 !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}
.SaveCalendar-btnLink-cFIw7:hover {
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	outline: 0 !important;
	text-decoration: underline;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	border: 0px !important;
}
.SaveCalendar-btnLinkPrimary-lVbQz,
.SaveCalendar-btnLinkPrimary-lVbQz:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.SaveCalendar-btnLinkPrimary-lVbQz:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.SaveCalendar-btnLinkSecondary-pYepx,
.SaveCalendar-btnLinkSecondary-pYepx:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-size: 16px;
	font-weight: 500;
	border-bottom: 1px solid var(--common-link-color) !important;
	border-radius: 0 !important;
	padding: 0 !important;
}
.SaveCalendar-btnLinkSecondary-pYepx:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-weight: 500;
	text-decoration: none !important;
	border-bottom: 1px solid var(--common-link-color) !important;
}
.SaveCalendar-searchFilterPopover-j3pmK {
	position: absolute;
	top: 57px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	visibility: visible;
	background: var(--primary-white-bg);
	-o-border-image: initial;
	   border-image: initial;
	-webkit-box-shadow: 0px 3px 6px #00000029;
	        box-shadow: 0px 3px 6px #00000029;
	border-radius: 12px;
}
.SaveCalendar-searchFilterPopoverFull-fPaFk {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background: var(--primary-white-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}
.SaveCalendar-searchFilterPopoverOverlay-MPDLu {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	bottom: 0;
}
.SaveCalendar-searchFilterPopoverContent-JsM3K {
	min-width: 370px;
	padding: 26px 26px 16px;
	height: 294px;
}
.SaveCalendar-searchFilterCloseIcon-cTbpt {
	font-size: 30px;
	color: var(--modalText-color);
}
.SaveCalendar-searchFilterPopoverFooter-cnsMZ {
	width: 100%;
	position: relative;
	line-height: 0;
}
.SaveCalendar-displayTable-eb_7w {
	display: table;
	width: 100%;
	vertical-align: middle;
}
.SaveCalendar-displayTableRow-OZ814 {
	display: table-row;
	vertical-align: middle;
}
.SaveCalendar-displayTableCell-GjAwt {
	display: table-cell;
	vertical-align: middle;
}
.SaveCalendar-displayInlineBlock-zVEk8 {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}
.SaveCalendar-fullWidth-M6bA1 {
	width: 100% !important;
}
.SaveCalendar-captionTitle-xdCdZ {
	font-size: 18px;
}
.SaveCalendar-showTabletSection-tfOMJ {
	display: none !important;
}
.SaveCalendar-incrementDecrementButton-H0MyY {
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	display: block;
	overflow: hidden;
	-webkit-appearance: none;
}
.SaveCalendar-commonBorder-PSdfC {
	border: 1px solid transparent !important;
	color: var(--modalText-color) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 60px !important;
	box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-appearance: none !important;
}
.SaveCalendar-textCenter-n3Xxm {
	text-align: center;
}
@media screen and (max-width: 768px) {
	.SaveCalendar-searchFilterPopoverFull-fPaFk {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		border: 1px solid var(--primary-white-bg);
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
	}

	.SaveCalendar-searchFilterPopoverContent-JsM3K {
		min-width: 320px;
		padding: 15px 15px 70px !important;
		height: 100%;
		min-height: 50vh;
		overflow: hidden;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.SaveCalendar-searchFilterPopoverHeader-u94kx {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 10px 15px;
		background: var(--primary-white-bg);
	}

	.SaveCalendar-searchFilterPopoverFooter-cnsMZ {
		font-weight: 600;
		position: fixed;
		top: 38%;
		left: 0;
		right: 0;
		background-color: transparent;
		z-index: 10;
	}

	.SaveCalendar-textSize-ZkM1a {
		font-size: 20px;
		font-weight: 600;
		display: block;
		width: 100% !important;
		height: 45px;
	}
}
.SaveCalendar-capitalizeText-jXI3D {
	text-transform: capitalize;
}
.SaveCalendar-hideBothTabletAndMobile-Zok61 {
	display: inline-block;
}
@media (max-width: 1199px) {
	.SaveCalendar-hideBothTabletAndMobile-Zok61 {
		display: none !important;
	}
}
@media screen and (max-width: 350px) {
	.SaveCalendar-btnFontsize-W0Rzv {
		font-size: 12px !important;
	}
}
@media (max-width: 360px) {
	.SaveCalendar-searchFilterCloseIcon-cTbpt {
		font-size: 25px;
	}
}
.SaveCalendar-transmissionBottom-sNw1c {
	padding-bottom: 21px !important;
}
.SaveCalendar-marginTop20-JGExM {
	margin-top: 35px;
}
.SaveCalendar-marginRight15-eUgcW {
	margin-right: 15px !important;
}
.SaveCalendar-marginNone-x2C2d {
	margin: 0 !important;
}
.SaveCalendar-paddingNone-kXjmV {
	padding: 0 !important;
}
.SaveCalendar-infoPadding-eJmKp {
	padding-right: 6px;
}
@media(min-width:768px) {
	.SaveCalendar-pullRight-sB9Sl {
		float: right;
	}
}
.SaveCalendar-displayFlex-VzfeP {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}
@media(max-width:767px) {

	.SaveCalendar-displayFlex-VzfeP {
		-webkit-box-pack: justify;
		    -ms-flex-pack: justify;
		        justify-content: space-between;
	}

	.SaveCalendar-hideTabletSection-_dqtz {
		display: none !important;
	}

	.SaveCalendar-showTabletSection-tfOMJ {
		display: block !important;
	}
}
/*****************Apply Button Alignment Start **********************/
.SaveCalendar-applyBtnDesktop-tZW_o {
	text-align: right;
}
.SaveCalendar-applyBtn-U4bIe,
.SaveCalendar-applyBtn-U4bIe:hover,
.SaveCalendar-applyBtn-U4bIe:active,
.SaveCalendar-applyBtn-U4bIe:focus {
	background-color: var(--common-background-color) !important;
	color: var(--white-text) !important;
	border-radius: 6px;
	text-decoration: none;
	padding: 9px 15px 10px;
	font-size: 16px;
}
@media screen and (max-width: 991px) {
	.SaveCalendar-applyBtnDesktop-tZW_o {
		text-align: center;
	}

	.SaveCalendar-applyBtnDesktopRight-IOKc6 {
		text-align: right !important;
	}

	.SaveCalendar-applyBtnDesktopNoPaddingRight-kNZxE {
		padding-right: 0px !important;
	}
}
@media screen and (max-width: 767px) {
	.SaveCalendar-searchFilterPopoverFooter-cnsMZ {
		position: relative !important;
		top: inherit;
	}
}
/*****************Apply Button Alignment Start **********************/
/*************************** Header Modal Start **********************/
.SaveCalendar-activeItem-LyaI4 {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 6px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}
.SaveCalendar-activeItem-LyaI4:hover,
.SaveCalendar-activeItem-LyaI4:focus,
.SaveCalendar-activeItem-LyaI4:active {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border-radius: 6px;
}
.SaveCalendar-activeSection-s3cCu:first-child {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}
.SaveCalendar-currencyAndLangGrid-ZZkKo {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 12px;
}
@media (max-width:767px) {
	.SaveCalendar-currencyAndLangGrid-ZZkKo {
		grid-template-columns: repeat(2, 1fr);
	}
}
/*************************** Header Modal End **********************/
a {
  cursor: pointer;
}
.SaveCalendar-space1-tD9QG {
  margin-bottom: 6px;
}
.SaveCalendar-space2-EyXsY {
  margin-bottom: 12px;
}
.SaveCalendar-space3-d4EYA {
  margin-bottom: 18px;
}
.SaveCalendar-space4-z9fue {
  margin-bottom: 24px;
}
.SaveCalendar-space5-l9CPK {
  margin-bottom: 48px;
}
.SaveCalendar-spaceTop1-c9EzL {
  margin-top: 6px;
}
.SaveCalendar-spaceTop2-cosGs {
  margin-top: 12px;
}
.SaveCalendar-spaceTop3-n3jRv {
  margin-top: 18px;
}
.SaveCalendar-spaceTop4-k0Qgg {
  margin-top: 24px;
}
.SaveCalendar-spaceTop5-diYPC {
  margin-top: 48px;
}
.SaveCalendar-noMargin-y6Pe7 {
  margin: 0px;
}
.SaveCalendar-noPadding-nt7Pt {
  padding: 0px;
}
/* Common Helpers Style - Start */
.SaveCalendar-btnSmall-c0BGX {
	padding: 5px 0px;
}
.SaveCalendar-formGroup-tkqSn {
	margin-bottom: 20px;
}
.SaveCalendar-jumboInput-TOnxx {
	background-color: var(--primary-white-bg);
	height: 48px !important;
	font-size: 16px !important;
	padding: 0 20px !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 6px !important;
	box-shadow: inherit !important;
	-webkit-box-shadow: inherit;
	-webkit-appearance: none;
}
.SaveCalendar-formControlSelect-ERpb5 {
	background-color: var(--primary-white-bg);
	/* Drop Down Caret Icon*/
	-moz-appearance: none;
	     appearance: none;
	background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%);
	background-position: 97% 12px;
	background-size: 5px 6px, 5px 6px, 1px 1.5em;
	background-repeat: no-repeat;
	-webkit-box-shadow: none;
	box-shadow: none;
	height: 48px !important;
	font-size: 16px !important;
	padding: 0px 50px 0px 20px !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 6px !important;
	-webkit-appearance: none;
}
.SaveCalendar-formControlSelectLarge-msXQI {
	max-width: 100%;
}
.SaveCalendar-select-Vnfiy {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
}
.SaveCalendar-landingContainer-autrm {
	max-width: 912px;
	width: 100%;
	display: block;
	margin: 0 auto;
}
.SaveCalendar-landingTitle-kXPXZ {
	font-size: 32px;
	color: var(--common-text-color);
	margin: 0px 0px 30px 0px;
}
.SaveCalendar-landingStep-TVbfs {
	font-size: 14px;
	color: var(--modalText-color);
	font-weight: bold;
	text-transform: uppercase;
	margin: 0px 0px 6px 0px;
	display: block;
}
.SaveCalendar-landingStep2-oVtJx {
	font-size: 18px;
	color: var(--modalText-color);
	margin: 0px 0px 10px 0px;
	display: block;
}
.SaveCalendar-landingStep3-ia8O6 {
	font-size: 18px;
	color: var(--modalText-color);
	line-height: 1.43;
	font-weight: normal;
}
.SaveCalendar-landingContentTitle-_mwTX {
	font-size: 24px;
	color: var(--common-text-color);
	margin: 0px 0px 18px 0px;
}
.SaveCalendar-landingContent-I0AiT {
	margin-top: 60px;
	margin-bottom: 100px;
}
.SaveCalendar-landingMainContent-vJsat {
	padding: 43px 54px 170px;
	height: 650px;
	overflow-y: auto;
	overflow-x: hidden;
}
.SaveCalendar-landingLabel-W9uOO {
	font-size: 18px;
	font-weight: 500;
	margin-bottom: 10px;
	position: relative;

}
.SaveCalendar-bookingTitle-oaAAA {
	font-weight: normal;
	color: var(--common-text-color);
	margin: 0px;
	word-wrap: break-word;
	font-size: 28px;
	line-height: 36px;
	letter-spacing: -0.6px;
	padding-top: 2px;
	padding-bottom: 2px;
}
.SaveCalendar-bookText-hja0z {
	font-size: 16px;
	color: var(--common-text-color);
	font-weight: normal;
}
.SaveCalendar-radioInput-hNQmy {
	position: relative;
	height: 1.25em;
	width: 1.25em;
	margin-right: 10px !important;
	vertical-align: top;
}
.SaveCalendar-radioSize-HwcKn {
	height: 15px;
	width: 15px
}
.SaveCalendar-checkboxLabel-mLPg5 {
	color: var(--modalText-color);
	font-weight: normal;
	display: inline;
	padding: 0px 10px;
	margin: 0px;
	line-height: 1.1;
}
.SaveCalendar-landingCaption-Fa2Kl {
	color: var(--modalText-color);
	font-size: 16px;
	margin-bottom: 5px;
	font-weight: normal;
}
.SaveCalendar-listContainer-J9Qgw {
	padding: 0px;
	list-style-type: none;
}
.SaveCalendar-listContent-ITJHT {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}
.SaveCalendar-horizontalLineThrough-XEEJW {
	position: relative;
	z-index: 1;
	display: block;
	margin: 15px 0px;
	width: 100%;
	color: var(--modalText-color);
	text-align: center;
	font-size: 14px;
}
.SaveCalendar-helpPanelContainer-bWkJM {
	max-width: 320px;
}
.SaveCalendar-helpPanel-C3WL1 {
	margin: 60px 30px 0;
	border: 1px solid var(--primary-border);
	border-radius: 4px;
	width: 100%;
	padding: 26px;
	background: var(--primary-white-bg);
}
.SaveCalendar-helpPanelText-dKIaH {
	font-size: 16px;
	line-height: 150%;
	color: var(--modalText-color);
}
.SaveCalendar-helpPanelTextTitle-LYDgS {
	color: var(--common-text-color);
	display: block;
	width: 100%;
}
.SaveCalendar-incrementDecrementButton-H0MyY {
	max-width: 320px;
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 2px;
	display: block;
	overflow: hidden;
}
.SaveCalendar-incrementDecrementText-VpMxG {
	float: left;
	width: 60%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 20px 20px;
	height: 48px;
	margin: 0px;
	font-size: 18px;
	line-height: 1;
	vertical-align: middle;
	font-weight: normal;
	background: var(--primary-white-bg);
}
.SaveCalendar-iconButton-LDa5F {
	width: 20%;
	float: left;
	border-color: var(--primary-border);
	border-width: 0px 0px 0px 1px;
	border-radius: 0px;
	padding: 12px 20px;
	height: 48px;
	margin: 5px 0px;
	font-size: 15px;
	line-height: 1px;
	background: var(--primary-white-bg);
}
.SaveCalendar-iconButton-LDa5F:hover,
.SaveCalendar-iconButton-LDa5F:focus,
.SaveCalendar-iconButton-LDa5F:active {
	background: var(--primary-white-bg);
	border-color: var(--primary-border);
	border-width: 0px 0px 0px 1px;
	margin-left: 0px;
}
.SaveCalendar-checkBoxSection-SlS_9 {
	display: table-cell;
}
.SaveCalendar-checkBoxLabel-Qh_9K {
	padding: 0px 10px;
}
.SaveCalendar-textAlignRight-vayZQ {
	text-align: right;
}
.SaveCalendar-textAlignLeft-PBOq0 {
	text-align: left;
}
.SaveCalendar-textAlignCenter-VH_vs {
	text-align: center;
}
.SaveCalendar-noPadding-nt7Pt {
	padding: 0px;
}
.SaveCalendar-pullRight-sB9Sl {
	float: right;
}
.SaveCalendar-pullLeft-kbRmH {
	float: left;
}
.SaveCalendar-space5-l9CPK {
	margin-bottom: 30px;
}
.SaveCalendar-noMargin-y6Pe7 {
	margin: 0px;
}
.SaveCalendar-unorderedList-wgMv_ li {
	margin-bottom: 10px;
	padding: 0px;
}
.SaveCalendar-checkIcon-NWwyk {
	color: var(--btn-primary-bg);
	margin: 0px 10px 5px 0px;
}
.SaveCalendar-space3-d4EYA {
	margin-bottom: 18px;
}
.SaveCalendar-space4-z9fue {
	margin-bottom: 24px;
}
.SaveCalendar-spaceTop4-k0Qgg {
	margin-top: 24px;
}
.SaveCalendar-textHigh-PhyNU {
	font-size: 18px;
	color: var(--common-text-color);
	line-height: 1.43;
}
.SaveCalendar-textLow-vNGDw {
	font-size: 16px;
	color: var(--modalText-color);
	line-height: 1.43;
}
/* Common Helpers Style - End */
/** List Photo Cover Style - Start */
.SaveCalendar-listPhotoCover-uJ1tw {
	display: block;
	height: 147px;
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	vertical-align: bottom;
	overflow: hidden;
	background-color: var(--common-gray-bg-color);
	text-align: center;
	margin-top: 15px;
}
.SaveCalendar-listPhotoMedia-t8sGw {
	position: absolute;
	right: 0;
	left: 0;
	bottom: 0;
	top: 0;
}
.SaveCalendar-imgResponsive-QgUuo {
	height: 100%;
	width: auto;
	max-width: 100%;
}
.SaveCalendar-coverPhotoSelection-KBkds {
	position: absolute;
	bottom: 5px;
	left: 5px;
	width: 100px;
	height: 30px;
	background: var(--btn-primary-bg);
	color: var(--white-text);
	font-size: 14px;
	border-radius: 5px 12px 12px 5px;
	line-height: 30px;
}
.SaveCalendar-coverPhotoCheckbox-vc8JZ {
	margin: 0px !important;
	vertical-align: middle;
}
/** List Photo Cover Style - End */
.SaveCalendar-landingContainer-autrm {
	max-width: 912px;
	width: 100%;
	display: block;
	margin: 0 auto;
}
.SaveCalendar-landingContent-I0AiT {
	margin-top: 44px;
	margin-bottom: 100px;
}
.SaveCalendar-noPadding-nt7Pt {
	padding: 0px;
}
.SaveCalendar-landingContentTitle-_mwTX {
	font-size: 24px;
	color: var(--common-text-color);
	margin: 0px 0px 18px 0px;
}
.SaveCalendar-landingSaftyTitle-RA4gQ {
	font-size: 20px !important;
	color: var(--common-text-color);
	margin: 0px 0px 18px 0px;
}
.SaveCalendar-bookingLandingStep-GJ76s {
	font-size: 18px;
	color: var(--modalText-color);
	margin: 0px 0px 10px 0px;
	display: block;
}
.SaveCalendar-horizontalLineThrough-XEEJW {
	position: relative;
	z-index: 0;
	display: block;
	margin: 0px 0px 15px;
	width: 100%;
	color: var(--modalText-color);
	text-align: center;
	font-size: 14px;
	border-top: 1px solid var(--primary-border);
	-webkit-box-shadow: 0px -2px 10px #ccc !important;
	        box-shadow: 0px -2px 10px #ccc !important;
}
.SaveCalendar-space3-d4EYA {
	margin-bottom: 18px;
}
.SaveCalendar-spaceTop3-n3jRv {
	margin-top: 18px;
}
.SaveCalendar-space6-ulQEm {
	margin-bottom: 36px;
}
.SaveCalendar-BookingradioInput-L0Lf0 {
	height: 1.25em;
	width: 1.25em;
	margin-right: 5px;
	vertical-align: top;
}
.SaveCalendar-bookText-hja0z {
	font-size: 16px;
	color: var(--common-text-color);
	font-weight: normal;
	margin-left: 10px;
	display: block;
}
.SaveCalendar-subText-tz5w8 {
	color: var(--modalText-color);
	font-size: 16px;
	font-weight: 400;
	display: block;
}
.SaveCalendar-displayTable-eb_7w {
	display: table;
}
.SaveCalendar-displayTableCell-GjAwt {
	display: table-cell;
}
/** SyncCalendar Start **/
.SaveCalendar-landingText-dRGWc {
	margin: 0px;
	word-wrap: break-word;
	font-size: 19px;
	line-height: 24px;
	padding-top: 0px;
	padding-bottom: 0px;
}
.SaveCalendar-listType-D3HVJ {
	padding-left: 0;
	list-style: none;
}
.SaveCalendar-iconContainer-vzFiT {
	cursor: pointer;
	background-color: transparent;
	border: 0px;
	display: block;
}
.SaveCalendar-iconContainer-vzFiT:active,
.SaveCalendar-iconContainer-vzFiT:focus,
.SaveCalendar-iconContainer-vzFiT:hover,
.SaveCalendar-iconContainer-vzFiT:active:focus {
	border: 0px;
	background-color: var(--primary-white-bg);
	outline: none;
	-webkit-box-shadow: none;
	        box-shadow: none;
}
.SaveCalendar-iconSize-jxfut {
	height: 20px;
	width: 20px;
	color: var(--modalText-color);
}
.SaveCalendar-calenderText-j8o6u {
	font-size: 19px;
	color: var(--modalText-color);
}
.SaveCalendar-LineColor-jQwgJ {
	border-top: 1px solid var(--primary-border);
}
.SaveCalendar-btnContainer-_nvcV {
	color: var(--btn-primary-bg);
	font-size: 16px;
	text-decoration: none;
	border: 0px;
	cursor: pointer;
	margin: 0px;
	padding: 0px;
	text-align: left;
	-webkit-user-select: auto;
	   -moz-user-select: auto;
	    -ms-user-select: auto;
	        user-select: auto;
}
.SaveCalendar-btnContainer-_nvcV:hover,
.SaveCalendar-btnContainer-_nvcV:focus,
.SaveCalendar-btnContainer-_nvcV:active,
.SaveCalendar-btnContainer-_nvcV:active:focus {
	border: 0px;
	background-color: transparent;
	outline: none;
	-webkit-box-shadow: none;
	        box-shadow: none;
	color: var(--btn-primary-bg);
}
.SaveCalendar-displayTableCellVertical-yBViW {
	display: table-cell;
	vertical-align: middle;
}
.SaveCalendar-paddingLeft-njBEy {
	padding-left: 8px;
}
.SaveCalendar-iconColor-ZXS9N {
	color: var(--btn-primary-bg);
}
.SaveCalendar-space0-M4krK {
	margin-bottom: 0px;
}
.SaveCalendar-step3IconLeft-cCsy5 {
	display: inline-block;
}
.SaveCalendar-displayTableRow-OZ814 {
	display: table-row;
	width: 100%;
}
.SaveCalendar-displayTableCellWidth-oAJm7 {
	width: 5%
}
.SaveCalendar-displayTableCellTop-Yw1o_ {
	vertical-align: top;
}
.SaveCalendar-tableWidth-SdQx5 {
	margin-right: 8px;
}
.SaveCalendar-noFontWeight-MngMG {
	font-weight: normal;
}
.SaveCalendar-nextPosition-C_QZw {
	position: fixed;
	bottom: 0;
	width: 100%;
	background: var(--primary-white-bg);
	z-index: 4;
	padding: 30px 54px;
	max-width: 50%;
	margin: 0px 0px 0px auto;
	right: 0px;
	left: 0px;
	-webkit-box-shadow: 0px -7px 16px #00000008;
	        box-shadow: 0px -7px 16px #00000008;
}
.SaveCalendar-nextBackButtonCalendar-ubKUE {
	width: 62.5%;
}
.SaveCalendar-posRelative-cm2dK {
	position: relative;
}
.SaveCalendar-imagefeed-OQqoe {
	position: absolute;
	top: 20px;
	width: 30%;
	height: 50px;
	border: 1px solid var(--primary-border);
	padding: 7px 7px;
	border-radius: 5px;
	z-index: 8;
}
.SaveCalendar-caListimg-q_Ec2 {
	max-width: 55px;
	width: 100%;
	height: 35px;
	float: left;
	background-size: cover;
	background-position: top center;
	border-radius: 2px;
}
.SaveCalendar-caListPara-QShaf {
	float: left;
	width: 78%;
	padding: 0 0 0 10px;
}
.SaveCalendar-caListPara-QShaf h2 {
	margin: 0;
	font-size: 14px;
	font-weight: bold;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.SaveCalendar-caListPara-QShaf p {
	max-width: 100%;
	height: 20px;
	margin: 0 auto;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.SaveCalendar-marginLeft5-f89Yg {
	margin-left: 5px !important;
	margin-top: 2px;
}
.SaveCalendar-notAvailableColor-UV_U8 {
	background-color: var(--becomeHost-calendar-bookedDay-bg);
	height: 20px;
	width: 20px;
	display: inline-block;
	vertical-align: top;
	margin-right: 9px;
	border-radius: 10px;
}
.SaveCalendar-bookedColor-Yfth2 {
	background-color: var(--becomeHost-calendar-blockDay-bg);
	height: 20px;
	width: 20px;
	display: inline-block;
	vertical-align: top;
	margin-right: 9px;
	border-radius: 10px;
}
.SaveCalendar-availableColor-Ij9UR {
	background-color: var(--Calendar-availableColor);
	height: 20px;
	width: 20px;
	display: inline-block;
	vertical-align: top;
	margin-right: 9px;
	border-radius: 10px;
}
.SaveCalendar-specialColor-nyCKb {
	height: 20px;
	width: 20px;
	display: inline-block;
	vertical-align: top;
	margin-right: 9px;
	background-color: var(--becomeHost-calendar-specialDay-bg);
	border-radius: 10px;
}
.SaveCalendar-fullWidth-M6bA1 {
	width: 100% !important;
	max-width: 100% !important;
}
.SaveCalendar-noMarginMaximum-Ax0Qy {
	margin: 0px !important;
}
.SaveCalendar-maximumSpace2-IPYg3 {
	margin-bottom: 12px !important;
}
.SaveCalendar-maximumCharcter-N3u6W {
	font-size: 14px;
	padding-left: 5px;
	vertical-align: middle;
}
.SaveCalendar-maximumCharColor-wGzhX {
	color: var(--alert-color)
}
.SaveCalendar-requiredMessage-GIiPY {
	color: var(--alert-color);
	display: block;
	margin-bottom: 10px;
}
.SaveCalendar-infoIconCss-gZJok {
	display: inline-block;
	margin: 0px 4px;
}
.SaveCalendar-infoIconCss-gZJok:hover .SaveCalendar-infoIconCss-gZJok {
	display: none;
}
.SaveCalendar-deliveryInfo-PJ1ay {
	top: 30px;
	min-width: 273px;
}
.SaveCalendar-stepGrid-VbYFs {
	display: grid;
	grid-template-columns: 50% 50%;
	background: -webkit-gradient(linear, right top, left top, color-stop(50%, rgba(255, 255, 255, 1)), color-stop(48%, rgba(249, 249, 249, 1)));
	background: linear-gradient(270deg, rgba(255, 255, 255, 1) 50%, rgba(249, 249, 249, 1) 48%);
}
.SaveCalendar-stepSizeCss-FQdYE {
	font-size: 24px;
}
.SaveCalendar-nextBackButton-d973p {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}
.SaveCalendar-leftBg-am4ic {
	background: var(--common-gray-bg-color);
	padding: 93px 54px 0;
	position: fixed;
	width: 50%;
	left: 0;
	z-index: -1;
	height: 100vh;
}
.SaveCalendar-titleWidth-aB_KB {
	max-width: 455px;
	padding: 93px 54px 0;
}
.SaveCalendar-stepFooterImage-CGxn4 {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 50%;
}
.SaveCalendar-noMargin-y6Pe7 {
	margin-bottom: 0;
}
.SaveCalendar-saveColor-fUbwF {
	color: var(--common-link-color) !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	border-bottom: 1px solid var(--common-link-color);
	text-decoration: none !important;
}
.SaveCalendar-searchToolTip-JrFZ6 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}
.SaveCalendar-locationTipCss-CZNL3 {
	color: var(--modalText-color);
}
.SaveCalendar-fullWidthCalendar-vyqH7 {
	width: 100% !important;
	max-width: 1520px !important;
	padding: 0 54px 30px;
}
.SaveCalendar-checkBoxLeft-qqkdR {
	padding-left: 8px;
}
.SaveCalendar-checkBoxFlex-TK2zp {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.SaveCalendar-alignBase-WDNra {
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
}
.SaveCalendar-reviewGuestFlex-kmOMK {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}
.SaveCalendar-becomeAHostSelect-r6R_X {
	background-position: 96% 7px !important;
}
.SaveCalendar-calenderColorText-U6Ofo {
	display: inline-block;
	font-size: 16px;
	margin-right: 10px;
	border: 1px solid var(--primary-border);
	border-radius: 20px;
	padding: 10px;
	margin-bottom: 0;
}
.SaveCalendar-bookedWidth-tW5s2 {
	display: inline-block;
	font-size: 16px;
	margin-right: 10px;
	border: 1px solid var(--primary-border);
	border-radius: 20px;
	padding: 10px;
	margin-bottom: 0;
}
.SaveCalendar-userRight-fYwoj img {
	border: 2px solid var(--common-link-color);
	border-radius: 50%;
	display: inline-block;
	padding: 5px;
	background-color: transparent;
}
.SaveCalendar-sayCss-jx_R5 {
	width: 44px;
}
.SaveCalendar-listIntroBgSection-nypci {
	padding-top: 73px;
	padding-bottom: 63px;
}
.SaveCalendar-footerImageOnboard-ZQmj9 {
	position: absolute;
	z-index: -1;
	width: 100%;
	left: 0;
	bottom: 0;
}
.SaveCalendar-footerFullWidth-NLkpn {
	max-width: 100%;
}
.SaveCalendar-bulbIcon-wB10u {
	width: 24px;
}
.SaveCalendar-brandImg-QAdyE img {
	max-width: 180px;
	height: 60px;
	-o-object-fit: contain;
	   object-fit: contain;
}
.SaveCalendar-stepLogo-eIX8H {
	margin: 0 0 20px;
}
.SaveCalendar-syncCalendarBtn-yLgEu{
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 6px;
}
@media (max-width: 1200px) and (min-width: 768px) {
	.SaveCalendar-stepGrid-VbYFs {
		height: 50vh;
	}
}
@media screen and (orientation:landscape) {
	.SaveCalendar-footerImageOnboard-ZQmj9 {
		position: static;
	}
}
@media (max-width: 1024px) and (min-width: 768px) {
	.SaveCalendar-nextPosition-C_QZw {
		padding: 15px 15px 15px;
		max-width: 100%;
	}

	.SaveCalendar-nextBackButtonCalendar-ubKUE {
		width: 100%;
	}

	.SaveCalendar-helpPanel-C3WL1 {
		margin: 60px 13px 0;
	}

	.SaveCalendar-caListPara-QShaf {
		float: left;
		width: 70%;
		padding: 0 0 0 10px;
	}

	.SaveCalendar-marginLeft5-f89Yg {
		margin-left: 10px !important;
	}

	.SaveCalendar-leftBg-am4ic {
		height: 100vh;
	}

	.SaveCalendar-landingMainContent-vJsat {
		height: calc(100vh - 50px);
		padding: 25px 25px 170px;
	}

	.SaveCalendar-locationOverflowHidden-vMvL4 {
		overflow-y: initial;
	}

	.SaveCalendar-stepFooterImage-CGxn4 {
		left: 0;
		right: auto;
		width: 50%;
		position: fixed;
		z-index: -1;
	}
}
/** SyncCalendar End **/
@media screen and (max-width: 991px) {
	.SaveCalendar-bulbIcon-wB10u {
		margin-right: 7px;
	}
}
@media screen and (max-width: 767.98px) {
	.SaveCalendar-calenderColorText-U6Ofo {
		display: inline-block;
		width: 100%;
		font-size: 18px;
	}

	.SaveCalendar-bookedWidth-tW5s2 {
		width: 100% !important;
		margin-bottom: 10px;
	}

	.SaveCalendar-imagefeed-OQqoe {
		width: 100%;
		left: 0;
		top: 0;
	}

	.SaveCalendar-nextPosition-C_QZw {
		padding: 20px 20px;
		max-width: 100%;
	}

	.SaveCalendar-nextBackButtonCalendar-ubKUE {
		width: 100%;
	}

	.SaveCalendar-button-_yUqu {
		margin-top: 10px;
	}

	.SaveCalendar-horizontalLineThrough-XEEJW {
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
	}

	.SaveCalendar-caListPara-QShaf {
		float: left;
		width: 70%;
		padding: 0 0 0 10px;
	}

	.SaveCalendar-marginLeft5-f89Yg {
		margin-left: 10px !important;
	}

	.SaveCalendar-leftBg-am4ic {
		display: none;
	}

	.SaveCalendar-stepGrid-VbYFs {
		grid-template-columns: 100%;
	}

	.SaveCalendar-landingMainContent-vJsat {
		padding: 25px 20px 120px;
		height: auto;
	}

	.SaveCalendar-imagefeed-OQqoe {
		width: 100%;
		left: 0;
		top: 0;
	}

	.SaveCalendar-landingContent-I0AiT {
		margin-top: 20px;
		padding: 0;
	}

	.SaveCalendar-landingContentTitle-_mwTX {
		font-size: 20px;
	}

	.SaveCalendar-calenderColorText-U6Ofo,
	.SaveCalendar-bookedWidth-tW5s2 {
		font-size: 14px !important;
		margin-bottom: 10px;
	}

	.SaveCalendar-caListPara-QShaf {
		float: left;
		width: 70%;
		padding: 0 0 0 10px;
	}

	.SaveCalendar-minMaxMobile-WgrjS {
		padding: 25px 20px 170px;
	}

	.SaveCalendar-fullWidthCalendar-vyqH7 {
		padding: 0 15px;
	}

	.SaveCalendar-titleWidth-aB_KB {
		display: none;
	}

	.SaveCalendar-stepGrid-VbYFs {
		background: unset;
	}

}
@media (min-width: 768px) and (max-width: 1199.98px) {
	.SaveCalendar-fullWidthCalendar-vyqH7 {
		padding: 0 30px;
	}
}
@media screen and (max-width: 340px) {
	.SaveCalendar-landingMainContent-vJsat {
		padding: 25px 20px 160px;
	}
}
.SaveCalendar-saveCalendarContainer-v56T7 {
    padding: 24px;
    border: 1px solid var(--primary-border);
    border-radius: 12px;
}
.SaveCalendar-selectedDatesBox-IKWqH {
    padding: 7px 10px 10px;
    font-size: 14px;
    line-height: 24px;
    color: rgb(72, 72, 72);
    border: 1px solid var(--primary-border);
    border-radius: 5px;
    height: 43px;
}
.SaveCalendar-arrowIcon-ZDjjV {
    vertical-align: middle;
    fill: rgb(72, 72, 72);
    height: 24px;
    width: 24px;
    margin: 0px 12px;
}
.SaveCalendar-loaderContainer-vwjTm {
    display: inline;
    padding-right: 0px;
}
.SaveCalendar-landingContentTitle-_mwTX {
    margin: 0px 0px 18px 0px;
}
.SaveCalendar-floatLeftInput-ndwC0 {
    float: left;
}
.SaveCalendar-inputHeight-ZrRFn {
    height: 48px;
    -webkit-box-shadow: inherit;
            box-shadow: inherit;
    border: 1px solid var(--primary-border)
}
.SaveCalendar-aBlockWrap-cVIxa {
    overflow: hidden;
}
.SaveCalendar-aBWLeft-JGPGA,
.SaveCalendar-aBWRight-K41WC {
    width: 50%;
    float: left;
}
.SaveCalendar-aBWLeft-JGPGA .SaveCalendar-btnBg-tFuHN {
    border-radius: 6px 0 0 6px;
}
.SaveCalendar-aBWRight-K41WC .SaveCalendar-btnBg-tFuHN {
    border-radius: 0 6px 6px 0;
}
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN {
    width: 100%;
    height: 48px;
    border-color: var(--primary-border);
    color: var(--btn-primary-bg);
    font-size: 18px;
}
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN:hover,
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN:active,
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN:focus,
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN.SaveCalendar-active-yl9G3 {
    background: var(--btn-primary-bg);
    color: var(--white-text);
}
.SaveCalendar-textRight-v_L7Y {
    text-align: right;
}
.SaveCalendar-sDateWrap-MMNuc {
    margin: 20px 0 10px;
}
.SaveCalendar-sDateWrap-MMNuc label {
    margin: 0;
}
.SaveCalendar-marginBottom-zSkzt {
    margin-bottom: 0;
}
@media (max-width: 1199.98px) {
    .SaveCalendar-saveCalendarContainer-v56T7 {
        padding: 20px 15px 45px;
        margin-top: 50px;
    }
}
@media (min-width:768px) and (max-width:991.98px) {
    .SaveCalendar-sDateWrap-MMNuc {
        margin: 20px 0 10px;
    }

    .SaveCalendar-sDateWrap-MMNuc h4 {
        font-size: 14px;
        margin: 0;
    }
}
@media screen and (max-width: 767.98px) {
    .SaveCalendar-saveCalendarContainer-v56T7 {
        margin-top: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css","webpack://./src/components/ListPlaceStep1/common.css","webpack://./src/components/ListPlaceStep1/ListPlaceStep1.css","webpack://./src/components/DayDragCalendar/SaveCalendar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;ACRA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzLA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,gCAAgC;CAChC,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;CACC,qDAAqD;CACrD,qBAAqB;CACrB,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;CACC,qGAA6F;SAA7F,6FAA6F;AAC9F;AAEA;;CAEC,8CAA8C;CAC9C,kDAAkD;CAClD,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;CACC,oDAAoD;CACpD,wDAAwD;CACxD,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;;CAEC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,sCAA8B;SAA9B,8BAA8B;AAC/B;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,gCAAgC;CAChC,gBAAgB;AACjB;AAEA;;CAEC,kDAAkD;CAClD,oDAAoD;CACpD,mCAAmC;CACnC,gCAAgC;CAChC,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,kDAAkD;CAClD,0DAA0D;CAC1D,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,sBAAsB;CACtB,qBAAqB;CACrB,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qBAAqB;CACrB,0BAA0B;CAC1B,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,sBAAsB;AACvB;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,eAAe;CACf,gBAAgB;CAChB,4DAA4D;CAC5D,2BAA2B;CAC3B,qBAAqB;AACtB;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;CAChB,gCAAgC;CAChC,4DAA4D;AAC7D;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,mBAAmB;CACnB,mCAAmC;CACnC,wBAAqB;IAArB,qBAAqB;CACrB,yCAAiC;SAAjC,iCAAiC;CACjC,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,SAAS;AACV;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,aAAa;AACd;AAEA;CACC,eAAe;CACf,6BAA6B;AAC9B;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,wBAAwB;AACzB;AAEA;CACC,wCAAwC;CACxC,wCAAwC;CACxC,mCAA2B;SAA3B,2BAA2B;CAC3B,8BAA8B;CAC9B,6CAA6C;CAC7C,qDAAqD;CACrD,mCAAmC;AACpC;AAGA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mCAAmC;CACpC;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,YAAY;CACb;AACD;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,6BAA6B;AAC9B;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,YAAY;CACb;AACD;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAe;KAAf,eAAe;AAChB;AAEA;;CAEC;EACC,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;CAC/B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,yBAAyB;CAC1B;AACD;AAEA,qEAAqE;AAErE;CACC,iBAAiB;AAClB;AAEA;;;;CAIC,2DAA2D;CAC3D,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,eAAe;AAChB;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;AACD;AAEA;CACC;EACC,6BAA6B;EAC7B,YAAY;CACb;AACD;AAEA,qEAAqE;AACrE,sEAAsE;AACtE;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;CACvC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;;;CAGC,gDAAgD;CAChD,wBAAwB;CACxB,kBAAkB;AACnB;AAEA;CACC,gDAAgD;CAChD,wBAAwB;CACxB,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;AAEA,oEAAoE;ACvdpE;EACE,eAAe;AACjB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,WAAW;AACb;AAEA;EACE,YAAY;AACd;AC/CA,iCAAiC;AAEjC;CACC,gBAAgB;AACjB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,yCAAyC;CACzC,uBAAuB;CACvB,0BAA0B;CAC1B,0BAA0B;CAC1B,kDAAkD;CAClD,6BAA6B;CAC7B,8BAA8B;CAC9B,2BAA2B;CAC3B,wBAAwB;AACzB;AAEA;CACC,yCAAyC;CACzC,wBAAwB;CACxB,qBAAgB;MAAhB,gBAAgB;CAChB,uHAAuH;CACvH,6BAA6B;CAC7B,4CAA4C;CAC5C,4BAA4B;CAC5B,wBAAwB;CACxB,gBAAgB;CAChB,uBAAuB;CACvB,0BAA0B;CAC1B,qCAAqC;CACrC,kDAAkD;CAClD,6BAA6B;CAC7B,wBAAwB;AACzB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;AACvB;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,cAAc;AACf;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,wBAAwB;AACzB;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,iBAAiB;CACjB,yBAAyB;CACzB,uBAAuB;CACvB,cAAc;AACf;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,wBAAwB;CACxB,cAAc;AACf;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,wBAAwB;AACzB;AAEA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;AAEA;CACC,wBAAwB;CACxB,aAAa;CACb,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;;AAEnB;AAEA;CACC,mBAAmB;CACnB,+BAA+B;CAC/B,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;AACpB;AAEA;CACC,YAAY;CACZ;AACD;AAEA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,gBAAgB;AACjB;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;CACC,YAAY;CACZ,qBAAqB;AACtB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,6BAA6B;CAC7B,kBAAkB;CAClB,eAAe;AAChB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,mBAAmB;CACnB,uCAAuC;CACvC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,mCAAmC;AACpC;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,6BAA6B;AAC9B;AAEA;CACC,+BAA+B;CAC/B,cAAc;CACd,WAAW;AACZ;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;AAEA;CACC,WAAW;CACX,UAAU;CACV,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,mBAAmB;CACnB,mCAAmC;AACpC;AAEA;CACC,UAAU;CACV,WAAW;CACX,mCAAmC;CACnC,6BAA6B;CAC7B,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,mCAAmC;AACpC;AAEA;;;CAGC,mCAAmC;CACnC,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;AACjB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,YAAY;AACb;AAEA;CACC,YAAY;AACb;AAEA;CACC,WAAW;AACZ;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;AAEA;CACC,4BAA4B;CAC5B,wBAAwB;AACzB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,iBAAiB;AAClB;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,iBAAiB;AAClB;AAEA,+BAA+B;AAE/B,oCAAoC;AAEpC;CACC,cAAc;CACd,aAAa;CACb,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;CAChB,6CAA6C;CAC7C,kBAAkB;CAClB,gBAAgB;AACjB;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,SAAS;CACT,MAAM;AACP;AAEA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;AAChB;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,YAAY;CACZ,iCAAiC;CACjC,wBAAwB;CACxB,eAAe;CACf,gCAAgC;CAChC,iBAAiB;AAClB;AAEA;CACC,sBAAsB;CACtB,sBAAsB;AACvB;AAEA,kCAAkC;AAElC;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,cAAc;AACf;AAEA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;AAEA;CACC,YAAY;AACb;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,wBAAwB;AACzB;AAEA;CACC,0BAA0B;CAC1B,+BAA+B;CAC/B,wBAAwB;AACzB;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,wBAAwB;CACxB,cAAc;AACf;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,oBAAoB;CACpB,WAAW;CACX,6BAA6B;CAC7B,kBAAkB;CAClB,eAAe;CACf,2CAA2C;CAC3C,iDAAyC;SAAzC,yCAAyC;AAC1C;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,cAAc;CACd,aAAa;CACb,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;AACf;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;AAEA;CACC,cAAc;AACf;AAEA;CACC,mBAAmB;AACpB;AAEA,yBAAyB;AAEzB;CACC,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,WAAW;CACX,cAAc;AACf;AAEA;;;;CAIC,WAAW;CACX,yCAAyC;CACzC,aAAa;CACb,wBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,YAAY;CACZ,WAAW;CACX,6BAA6B;AAC9B;AAEA;CACC,eAAe;CACf,6BAA6B;AAC9B;AAEA;CACC,2CAA2C;AAC5C;AAEA;CACC,4BAA4B;CAC5B,eAAe;CACf,qBAAqB;CACrB,WAAW;CACX,eAAe;CACf,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,yBAAiB;IAAjB,sBAAiB;KAAjB,qBAAiB;SAAjB,iBAAiB;AAClB;AAEA;;;;CAIC,WAAW;CACX,6BAA6B;CAC7B,aAAa;CACb,wBAAgB;SAAhB,gBAAgB;CAChB,4BAA4B;AAC7B;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;AAEA;CACC;AACD;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,SAAS;CACT,WAAW;CACX,mCAAmC;CACnC,UAAU;CACV,kBAAkB;CAClB,cAAc;CACd,wBAAwB;CACxB,UAAU;CACV,SAAS;CACT,2CAAmC;SAAnC,mCAAmC;AACpC;AAEA;CACC,YAAY;AACb;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,YAAY;CACZ,uCAAuC;CACvC,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;AACX;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,+BAA+B;CAC/B,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,UAAU;CACV,mBAAmB;AACpB;AAEA;CACC,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,YAAY;CACZ,cAAc;CACd,4BAA4B;CAC5B,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;AAEA;CACC,2BAA2B;CAC3B,eAAe;AAChB;AAEA;CACC,yDAAyD;CACzD,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,wDAAwD;CACxD,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,gDAAgD;CAChD,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,mBAAmB;CACnB,iBAAiB;CACjB,0DAA0D;CAC1D,mBAAmB;AACpB;AAEA;CACC,sBAAsB;CACtB,0BAA0B;AAC3B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,sBAAsB;AACvB;AAEA;CACC;AACD;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,mBAAmB;AACpB;AAEA;CACC,qBAAqB;CACrB,eAAe;AAChB;AAGA;CACC,aAAa;AACd;AAEA;CACC,SAAS;CACT,gBAAgB;AACjB;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,2IAA2F;CAA3F,2FAA2F;AAC5F;AAEA;CACC,eAAe;AAChB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,mBAAe;KAAf,eAAe;AAChB;AAEA;CACC,uCAAuC;CACvC,oBAAoB;CACpB,eAAe;CACf,UAAU;CACV,OAAO;CACP,WAAW;CACX,aAAa;AACd;AAEA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,UAAU;AACX;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,0CAA0C;CAC1C,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,iDAAiD;CACjD,gCAAgC;AACjC;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;CACC,6BAA6B;AAC9B;AAEA;CACC,sBAAsB;CACtB,4BAA4B;CAC5B,oBAAoB;AACrB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AAEA;CACC,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;AACtB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;CACC,uCAAuC;AACxC;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kBAAkB;CAClB,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,6BAA6B;AAC9B;AAEA;CACC,WAAW;AACZ;AAEA;CACC,iBAAiB;CACjB,oBAAoB;AACrB;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,OAAO;CACP,SAAS;AACV;AAEA;CACC,eAAe;AAChB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;AACpB;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;AACT;AAEA;CACC;EACC,YAA0B;CAC3B;AACD;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;AAEA;CACC;EACC,uBAAuB;EACvB,eAAe;CAChB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,0BAA0B;EAC1B,wBAAwB;CACzB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,OAAO;EACP,WAAW;EACX,UAAU;EACV,eAAe;EACf,WAAW;CACZ;AACD;AAGA,uBAAuB;AACvB;CACC;EACC,iBAAiB;CAClB;AACD;AAEA;CACC;EACC,qBAAqB;EACrB,WAAW;EACX,eAAe;CAChB;;CAEA;EACC,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,OAAO;EACP,MAAM;CACP;;CAEA;EACC,kBAAkB;EAClB,eAAe;CAChB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;CACR;;CAEA;EACC,WAAW;EACX,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,wBAAwB;EACxB,YAAY;CACb;;CAEA;EACC,WAAW;EACX,OAAO;EACP,MAAM;CACP;;CAEA;EACC,gBAAgB;EAChB,UAAU;CACX;;CAEA;EACC,eAAe;CAChB;;CAEA;;EAEC,0BAA0B;EAC1B,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,iBAAiB;CAClB;;AAED;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;ACpjCA;IACI,aAAa;IACb,uCAAuC;IACvC,mBAAmB;AACvB;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;AAChB;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;AAEA;IACI,wBAAwB;AAC5B;AAEA;IACI,WAAW;AACf;AAEA;IACI,YAAY;IACZ,2BAAmB;YAAnB,mBAAmB;IACnB;AACJ;AAEA;IACI,gBAAgB;AACpB;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;AAEA;IACI,0BAA0B;AAC9B;AAEA;IACI,0BAA0B;AAC9B;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,4BAA4B;IAC5B,eAAe;AACnB;AAEA;;;;IAII,iCAAiC;IACjC,wBAAwB;AAC5B;AAEA;IACI,iBAAiB;AACrB;AAEA;IACI,mBAAmB;AACvB;AAEA;IACI,SAAS;AACb;AAEA;IACI,gBAAgB;AACpB;AAGA;IACI;QACI,uBAAuB;QACvB,gBAAgB;IACpB;AACJ;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;AACJ;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 8px 12px 8px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 6px !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover {\n\tbackground: var(--common-background-color) !important;\n\toutline: 0 !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover img {\n\tfilter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--btn-primary-bg) !important;\n\tbackground-color: var(--btn-primary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--btn-primary-bg-hover) !important;\n\tbackground-color: var(--btn-primary-bg-hover) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\tborder-radius: 6px;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\tbox-shadow: inherit !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\ttext-decoration: none !important;\n\tfont-weight: 500;\n}\n\n.btnSecondary,\n.btnSecondary:focus {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\twhite-space: pre-line;\n}\n\n.btnSecondary:hover {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-hover-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnLink,\n.btnLink:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.btnLink:hover {\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\toutline: 0 !important;\n\ttext-decoration: underline;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tborder: 0px !important;\n}\n\n.btnLinkPrimary,\n.btnLinkPrimary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkPrimary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkSecondary,\n.btnLinkSecondary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n\tborder-radius: 0 !important;\n\tpadding: 0 !important;\n}\n\n.btnLinkSecondary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-weight: 500;\n\ttext-decoration: none !important;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 57px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tvisibility: visible;\n\tbackground: var(--primary-white-bg);\n\tborder-image: initial;\n\tbox-shadow: 0px 3px 6px #00000029;\n\tborder-radius: 12px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.searchFilterPopoverContent {\n\tmin-width: 370px;\n\tpadding: 26px 26px 16px;\n\theight: 294px;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--modalText-color);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 18px;\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.incrementDecrementButton {\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tdisplay: block;\n\toverflow: hidden;\n\t-webkit-appearance: none;\n}\n\n.commonBorder {\n\tborder: 1px solid transparent !important;\n\tcolor: var(--modalText-color) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 60px !important;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-appearance: none !important;\n}\n\n\n.textCenter {\n\ttext-align: center;\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tborder: 1px solid var(--primary-white-bg);\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\tmin-width: 320px;\n\t\tpadding: 15px 15px 70px !important;\n\t\theight: 100%;\n\t\tmin-height: 50vh;\n\t\toverflow: hidden;\n\t\toverflow-y: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 10px 15px;\n\t\tbackground: var(--primary-white-bg);\n\t}\n\n\t.searchFilterPopoverFooter {\n\t\tfont-weight: 600;\n\t\tposition: fixed;\n\t\ttop: 38%;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbackground-color: transparent;\n\t\tz-index: 10;\n\t}\n\n\t.textSize {\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\theight: 45px;\n\t}\n}\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n.hideBothTabletAndMobile {\n\tdisplay: inline-block;\n}\n\n@media (max-width: 1199px) {\n\t.hideBothTabletAndMobile {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 12px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n.transmissionBottom {\n\tpadding-bottom: 21px !important;\n}\n\n.marginTop20 {\n\tmargin-top: 35px;\n}\n\n.marginRight15 {\n\tmargin-right: 15px !important;\n}\n\n.marginNone {\n\tmargin: 0 !important;\n}\n\n.paddingNone {\n\tpadding: 0 !important;\n}\n\n.infoPadding {\n\tpadding-right: 6px;\n}\n\n@media(min-width:768px) {\n\t.pullRight {\n\t\tfloat: right;\n\t}\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n}\n\n@media(max-width:767px) {\n\n\t.displayFlex {\n\t\tjustify-content: space-between;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n.applyBtn,\n.applyBtn:hover,\n.applyBtn:active,\n.applyBtn:focus {\n\tbackground-color: var(--common-background-color) !important;\n\tcolor: var(--white-text) !important;\n\tborder-radius: 6px;\n\ttext-decoration: none;\n\tpadding: 9px 15px 10px;\n\tfont-size: 16px;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t\ttop: inherit;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n/*************************** Header Modal Start **********************/\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 6px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder-radius: 6px;\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.currencyAndLangGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 12px;\n}\n\n@media (max-width:767px) {\n\t.currencyAndLangGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/","a {\n  cursor: pointer;\n}\n\n.space1 {\n  margin-bottom: 6px;\n}\n\n.space2 {\n  margin-bottom: 12px;\n}\n\n.space3 {\n  margin-bottom: 18px;\n}\n\n.space4 {\n  margin-bottom: 24px;\n}\n\n.space5 {\n  margin-bottom: 48px;\n}\n\n.spaceTop1 {\n  margin-top: 6px;\n}\n\n.spaceTop2 {\n  margin-top: 12px;\n}\n\n.spaceTop3 {\n  margin-top: 18px;\n}\n\n.spaceTop4 {\n  margin-top: 24px;\n}\n\n.spaceTop5 {\n  margin-top: 48px;\n}\n\n.noMargin {\n  margin: 0px;\n}\n\n.noPadding {\n  padding: 0px;\n}\n","@import '../../components/common.css';\n@import 'common.css';\n\n/* Common Helpers Style - Start */\n\n.btnSmall {\n\tpadding: 5px 0px;\n}\n\n.formGroup {\n\tmargin-bottom: 20px;\n}\n\n.jumboInput {\n\tbackground-color: var(--primary-white-bg);\n\theight: 48px !important;\n\tfont-size: 16px !important;\n\tpadding: 0 20px !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 6px !important;\n\tbox-shadow: inherit !important;\n\t-webkit-box-shadow: inherit;\n\t-webkit-appearance: none;\n}\n\n.formControlSelect {\n\tbackground-color: var(--primary-white-bg);\n\t/* Drop Down Caret Icon*/\n\tappearance: none;\n\tbackground-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%);\n\tbackground-position: 97% 12px;\n\tbackground-size: 5px 6px, 5px 6px, 1px 1.5em;\n\tbackground-repeat: no-repeat;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\theight: 48px !important;\n\tfont-size: 16px !important;\n\tpadding: 0px 50px 0px 20px !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 6px !important;\n\t-webkit-appearance: none;\n}\n\n.formControlSelectLarge {\n\tmax-width: 100%;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n}\n\n.landingContainer {\n\tmax-width: 912px;\n\twidth: 100%;\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n.landingTitle {\n\tfont-size: 32px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px 0px 30px 0px;\n}\n\n.landingStep {\n\tfont-size: 14px;\n\tcolor: var(--modalText-color);\n\tfont-weight: bold;\n\ttext-transform: uppercase;\n\tmargin: 0px 0px 6px 0px;\n\tdisplay: block;\n}\n\n.landingStep2 {\n\tfont-size: 18px;\n\tcolor: var(--modalText-color);\n\tmargin: 0px 0px 10px 0px;\n\tdisplay: block;\n}\n\n.landingStep3 {\n\tfont-size: 18px;\n\tcolor: var(--modalText-color);\n\tline-height: 1.43;\n\tfont-weight: normal;\n}\n\n.landingContentTitle {\n\tfont-size: 24px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px 0px 18px 0px;\n}\n\n.landingContent {\n\tmargin-top: 60px;\n\tmargin-bottom: 100px;\n}\n\n.landingMainContent {\n\tpadding: 43px 54px 170px;\n\theight: 650px;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\n\n.landingLabel {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tmargin-bottom: 10px;\n\tposition: relative;\n\n}\n\n.bookingTitle {\n\tfont-weight: normal;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tword-wrap: break-word;\n\tfont-size: 28px;\n\tline-height: 36px;\n\tletter-spacing: -0.6px;\n\tpadding-top: 2px;\n\tpadding-bottom: 2px;\n}\n\n.bookText {\n\tfont-size: 16px;\n\tcolor: var(--common-text-color);\n\tfont-weight: normal;\n}\n\n.radioInput {\n\tposition: relative;\n\theight: 1.25em;\n\twidth: 1.25em;\n\tmargin-right: 10px !important;\n\tvertical-align: top;\n}\n\n.radioSize {\n\theight: 15px;\n\twidth: 15px\n}\n\n.checkboxLabel {\n\tcolor: var(--modalText-color);\n\tfont-weight: normal;\n\tdisplay: inline;\n\tpadding: 0px 10px;\n\tmargin: 0px;\n\tline-height: 1.1;\n}\n\n.landingCaption {\n\tcolor: var(--modalText-color);\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\tfont-weight: normal;\n}\n\n.listContainer {\n\tpadding: 0px;\n\tlist-style-type: none;\n}\n\n.listContent {\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: block;\n\tmargin: 15px 0px;\n\twidth: 100%;\n\tcolor: var(--modalText-color);\n\ttext-align: center;\n\tfont-size: 14px;\n}\n\n.helpPanelContainer {\n\tmax-width: 320px;\n}\n\n.helpPanel {\n\tmargin: 60px 30px 0;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 4px;\n\twidth: 100%;\n\tpadding: 26px;\n\tbackground: var(--primary-white-bg);\n}\n\n.helpPanelText {\n\tfont-size: 16px;\n\tline-height: 150%;\n\tcolor: var(--modalText-color);\n}\n\n.helpPanelTextTitle {\n\tcolor: var(--common-text-color);\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.incrementDecrementButton {\n\tmax-width: 320px;\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 2px;\n\tdisplay: block;\n\toverflow: hidden;\n}\n\n.incrementDecrementText {\n\tfloat: left;\n\twidth: 60%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tpadding: 20px 20px;\n\theight: 48px;\n\tmargin: 0px;\n\tfont-size: 18px;\n\tline-height: 1;\n\tvertical-align: middle;\n\tfont-weight: normal;\n\tbackground: var(--primary-white-bg);\n}\n\n.iconButton {\n\twidth: 20%;\n\tfloat: left;\n\tborder-color: var(--primary-border);\n\tborder-width: 0px 0px 0px 1px;\n\tborder-radius: 0px;\n\tpadding: 12px 20px;\n\theight: 48px;\n\tmargin: 5px 0px;\n\tfont-size: 15px;\n\tline-height: 1px;\n\tbackground: var(--primary-white-bg);\n}\n\n.iconButton:hover,\n.iconButton:focus,\n.iconButton:active {\n\tbackground: var(--primary-white-bg);\n\tborder-color: var(--primary-border);\n\tborder-width: 0px 0px 0px 1px;\n\tmargin-left: 0px;\n}\n\n.checkBoxSection {\n\tdisplay: table-cell;\n}\n\n.checkBoxLabel {\n\tpadding: 0px 10px;\n}\n\n.textAlignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.textAlignCenter {\n\ttext-align: center;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.space5 {\n\tmargin-bottom: 30px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.unorderedList li {\n\tmargin-bottom: 10px;\n\tpadding: 0px;\n}\n\n.checkIcon {\n\tcolor: var(--btn-primary-bg);\n\tmargin: 0px 10px 5px 0px;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.space4 {\n\tmargin-bottom: 24px;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px;\n}\n\n.textHigh {\n\tfont-size: 18px;\n\tcolor: var(--common-text-color);\n\tline-height: 1.43;\n}\n\n.textLow {\n\tfont-size: 16px;\n\tcolor: var(--modalText-color);\n\tline-height: 1.43;\n}\n\n/* Common Helpers Style - End */\n\n/** List Photo Cover Style - Start */\n\n.listPhotoCover {\n\tdisplay: block;\n\theight: 147px;\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tbackground-color: var(--common-gray-bg-color);\n\ttext-align: center;\n\tmargin-top: 15px;\n}\n\n.listPhotoMedia {\n\tposition: absolute;\n\tright: 0;\n\tleft: 0;\n\tbottom: 0;\n\ttop: 0;\n}\n\n.imgResponsive {\n\theight: 100%;\n\twidth: auto;\n\tmax-width: 100%;\n}\n\n.coverPhotoSelection {\n\tposition: absolute;\n\tbottom: 5px;\n\tleft: 5px;\n\twidth: 100px;\n\theight: 30px;\n\tbackground: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n\tfont-size: 14px;\n\tborder-radius: 5px 12px 12px 5px;\n\tline-height: 30px;\n}\n\n.coverPhotoCheckbox {\n\tmargin: 0px !important;\n\tvertical-align: middle;\n}\n\n/** List Photo Cover Style - End */\n\n.landingContainer {\n\tmax-width: 912px;\n\twidth: 100%;\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n.landingContent {\n\tmargin-top: 44px;\n\tmargin-bottom: 100px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.landingContentTitle {\n\tfont-size: 24px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px 0px 18px 0px;\n}\n\n.landingSaftyTitle {\n\tfont-size: 20px !important;\n\tcolor: var(--common-text-color);\n\tmargin: 0px 0px 18px 0px;\n}\n\n.bookingLandingStep {\n\tfont-size: 18px;\n\tcolor: var(--modalText-color);\n\tmargin: 0px 0px 10px 0px;\n\tdisplay: block;\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tz-index: 0;\n\tdisplay: block;\n\tmargin: 0px 0px 15px;\n\twidth: 100%;\n\tcolor: var(--modalText-color);\n\ttext-align: center;\n\tfont-size: 14px;\n\tborder-top: 1px solid var(--primary-border);\n\tbox-shadow: 0px -2px 10px #ccc !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.space6 {\n\tmargin-bottom: 36px;\n}\n\n.BookingradioInput {\n\theight: 1.25em;\n\twidth: 1.25em;\n\tmargin-right: 5px;\n\tvertical-align: top;\n}\n\n.bookText {\n\tfont-size: 16px;\n\tcolor: var(--common-text-color);\n\tfont-weight: normal;\n\tmargin-left: 10px;\n\tdisplay: block;\n}\n\n.subText {\n\tcolor: var(--modalText-color);\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tdisplay: block;\n}\n\n.displayTable {\n\tdisplay: table;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n}\n\n/** SyncCalendar Start **/\n\n.landingText {\n\tmargin: 0px;\n\tword-wrap: break-word;\n\tfont-size: 19px;\n\tline-height: 24px;\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n}\n\n.listType {\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.iconContainer {\n\tcursor: pointer;\n\tbackground-color: transparent;\n\tborder: 0px;\n\tdisplay: block;\n}\n\n.iconContainer:active,\n.iconContainer:focus,\n.iconContainer:hover,\n.iconContainer:active:focus {\n\tborder: 0px;\n\tbackground-color: var(--primary-white-bg);\n\toutline: none;\n\tbox-shadow: none;\n}\n\n.iconSize {\n\theight: 20px;\n\twidth: 20px;\n\tcolor: var(--modalText-color);\n}\n\n.calenderText {\n\tfont-size: 19px;\n\tcolor: var(--modalText-color);\n}\n\n.LineColor {\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.btnContainer {\n\tcolor: var(--btn-primary-bg);\n\tfont-size: 16px;\n\ttext-decoration: none;\n\tborder: 0px;\n\tcursor: pointer;\n\tmargin: 0px;\n\tpadding: 0px;\n\ttext-align: left;\n\tuser-select: auto;\n}\n\n.btnContainer:hover,\n.btnContainer:focus,\n.btnContainer:active,\n.btnContainer:active:focus {\n\tborder: 0px;\n\tbackground-color: transparent;\n\toutline: none;\n\tbox-shadow: none;\n\tcolor: var(--btn-primary-bg);\n}\n\n.displayTableCellVertical {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.paddingLeft {\n\tpadding-left: 8px;\n}\n\n.iconColor {\n\tcolor: var(--btn-primary-bg);\n}\n\n.space0 {\n\tmargin-bottom: 0px;\n}\n\n.step3IconLeft {\n\tdisplay: inline-block;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCellWidth {\n\twidth: 5%\n}\n\n.displayTableCellTop {\n\tvertical-align: top;\n}\n\n.tableWidth {\n\tmargin-right: 8px;\n}\n\n.noFontWeight {\n\tfont-weight: normal;\n}\n\n.nextPosition {\n\tposition: fixed;\n\tbottom: 0;\n\twidth: 100%;\n\tbackground: var(--primary-white-bg);\n\tz-index: 4;\n\tpadding: 30px 54px;\n\tmax-width: 50%;\n\tmargin: 0px 0px 0px auto;\n\tright: 0px;\n\tleft: 0px;\n\tbox-shadow: 0px -7px 16px #00000008;\n}\n\n.nextBackButtonCalendar {\n\twidth: 62.5%;\n}\n\n.posRelative {\n\tposition: relative;\n}\n\n.imagefeed {\n\tposition: absolute;\n\ttop: 20px;\n\twidth: 30%;\n\theight: 50px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 7px 7px;\n\tborder-radius: 5px;\n\tz-index: 8;\n}\n\n.caListimg {\n\tmax-width: 55px;\n\twidth: 100%;\n\theight: 35px;\n\tfloat: left;\n\tbackground-size: cover;\n\tbackground-position: top center;\n\tborder-radius: 2px;\n}\n\n.caListPara {\n\tfloat: left;\n\twidth: 78%;\n\tpadding: 0 0 0 10px;\n}\n\n.caListPara h2 {\n\tmargin: 0;\n\tfont-size: 14px;\n\tfont-weight: bold;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.caListPara p {\n\tmax-width: 100%;\n\theight: 20px;\n\tmargin: 0 auto;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.marginLeft5 {\n\tmargin-left: 5px !important;\n\tmargin-top: 2px;\n}\n\n.notAvailableColor {\n\tbackground-color: var(--becomeHost-calendar-bookedDay-bg);\n\theight: 20px;\n\twidth: 20px;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tmargin-right: 9px;\n\tborder-radius: 10px;\n}\n\n.bookedColor {\n\tbackground-color: var(--becomeHost-calendar-blockDay-bg);\n\theight: 20px;\n\twidth: 20px;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tmargin-right: 9px;\n\tborder-radius: 10px;\n}\n\n.availableColor {\n\tbackground-color: var(--Calendar-availableColor);\n\theight: 20px;\n\twidth: 20px;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tmargin-right: 9px;\n\tborder-radius: 10px;\n}\n\n.specialColor {\n\theight: 20px;\n\twidth: 20px;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tmargin-right: 9px;\n\tbackground-color: var(--becomeHost-calendar-specialDay-bg);\n\tborder-radius: 10px;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n\tmax-width: 100% !important;\n}\n\n.noMarginMaximum {\n\tmargin: 0px !important;\n}\n\n.maximumSpace2 {\n\tmargin-bottom: 12px !important;\n}\n\n.maximumCharcter {\n\tfont-size: 14px;\n\tpadding-left: 5px;\n\tvertical-align: middle;\n}\n\n.maximumCharColor {\n\tcolor: var(--alert-color)\n}\n\n.requiredMessage {\n\tcolor: var(--alert-color);\n\tdisplay: block;\n\tmargin-bottom: 10px;\n}\n\n.infoIconCss {\n\tdisplay: inline-block;\n\tmargin: 0px 4px;\n}\n\n\n.infoIconCss:hover .infoIconCss {\n\tdisplay: none;\n}\n\n.deliveryInfo {\n\ttop: 30px;\n\tmin-width: 273px;\n}\n\n.stepGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tbackground: linear-gradient(270deg, rgba(255, 255, 255, 1) 50%, rgba(249, 249, 249, 1) 48%);\n}\n\n.stepSizeCss {\n\tfont-size: 24px;\n}\n\n.nextBackButton {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 12px;\n\tflex-wrap: wrap;\n}\n\n.leftBg {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 93px 54px 0;\n\tposition: fixed;\n\twidth: 50%;\n\tleft: 0;\n\tz-index: -1;\n\theight: 100vh;\n}\n\n.titleWidth {\n\tmax-width: 455px;\n\tpadding: 93px 54px 0;\n}\n\n.stepFooterImage {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 50%;\n}\n\n.noMargin {\n\tmargin-bottom: 0;\n}\n\n.saveColor {\n\tcolor: var(--common-link-color) !important;\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: 1px solid var(--common-link-color);\n\ttext-decoration: none !important;\n}\n\n.searchToolTip {\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.locationTipCss {\n\tcolor: var(--modalText-color);\n}\n\n.fullWidthCalendar {\n\twidth: 100% !important;\n\tmax-width: 1520px !important;\n\tpadding: 0 54px 30px;\n}\n\n.checkBoxLeft {\n\tpadding-left: 8px;\n}\n\n.checkBoxFlex {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.alignBase {\n\talign-items: baseline;\n}\n\n.reviewGuestFlex {\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.becomeAHostSelect {\n\tbackground-position: 96% 7px !important;\n}\n\n.calenderColorText {\n\tdisplay: inline-block;\n\tfont-size: 16px;\n\tmargin-right: 10px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 20px;\n\tpadding: 10px;\n\tmargin-bottom: 0;\n}\n\n.bookedWidth {\n\tdisplay: inline-block;\n\tfont-size: 16px;\n\tmargin-right: 10px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 20px;\n\tpadding: 10px;\n\tmargin-bottom: 0;\n}\n\n.userRight img {\n\tborder: 2px solid var(--common-link-color);\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tpadding: 5px;\n\tbackground-color: transparent;\n}\n\n.sayCss {\n\twidth: 44px;\n}\n\n.listIntroBgSection {\n\tpadding-top: 73px;\n\tpadding-bottom: 63px;\n}\n\n.footerImageOnboard {\n\tposition: absolute;\n\tz-index: -1;\n\twidth: 100%;\n\tleft: 0;\n\tbottom: 0;\n}\n\n.footerFullWidth {\n\tmax-width: 100%;\n}\n\n.bulbIcon {\n\twidth: 24px;\n}\n\n.brandImg img {\n\tmax-width: 180px;\n\theight: 60px;\n\tobject-fit: contain;\n}\n\n.stepLogo {\n\tmargin: 0 0 20px;\n}\n.syncCalendarBtn{\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n}\n\n@media (max-width: 1200px) and (min-width: 768px) {\n\t.stepGrid {\n\t\theight: calc(100vh - 50vh);\n\t}\n}\n\n@media screen and (orientation:landscape) {\n\t.footerImageOnboard {\n\t\tposition: static;\n\t}\n}\n\n@media (max-width: 1024px) and (min-width: 768px) {\n\t.nextPosition {\n\t\tpadding: 15px 15px 15px;\n\t\tmax-width: 100%;\n\t}\n\n\t.nextBackButtonCalendar {\n\t\twidth: 100%;\n\t}\n\n\t.helpPanel {\n\t\tmargin: 60px 13px 0;\n\t}\n\n\t.caListPara {\n\t\tfloat: left;\n\t\twidth: 70%;\n\t\tpadding: 0 0 0 10px;\n\t}\n\n\t.marginLeft5 {\n\t\tmargin-left: 10px !important;\n\t}\n\n\t.leftBg {\n\t\theight: 100vh;\n\t}\n\n\t.landingMainContent {\n\t\theight: calc(100vh - 50px);\n\t\tpadding: 25px 25px 170px;\n\t}\n\n\t.locationOverflowHidden {\n\t\toverflow-y: initial;\n\t}\n\n\t.stepFooterImage {\n\t\tleft: 0;\n\t\tright: auto;\n\t\twidth: 50%;\n\t\tposition: fixed;\n\t\tz-index: -1;\n\t}\n}\n\n\n/** SyncCalendar End **/\n@media screen and (max-width: 991px) {\n\t.bulbIcon {\n\t\tmargin-right: 7px;\n\t}\n}\n\n@media screen and (max-width: 767.98px) {\n\t.calenderColorText {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t\tfont-size: 18px;\n\t}\n\n\t.bookedWidth {\n\t\twidth: 100% !important;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.imagefeed {\n\t\twidth: 100%;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\n\t.nextPosition {\n\t\tpadding: 20px 20px;\n\t\tmax-width: 100%;\n\t}\n\n\t.nextBackButtonCalendar {\n\t\twidth: 100%;\n\t}\n\n\t.button {\n\t\tmargin-top: 10px;\n\t}\n\n\t.horizontalLineThrough {\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n\n\t.caListPara {\n\t\tfloat: left;\n\t\twidth: 70%;\n\t\tpadding: 0 0 0 10px;\n\t}\n\n\t.marginLeft5 {\n\t\tmargin-left: 10px !important;\n\t}\n\n\t.leftBg {\n\t\tdisplay: none;\n\t}\n\n\t.stepGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.landingMainContent {\n\t\tpadding: 25px 20px 120px;\n\t\theight: auto;\n\t}\n\n\t.imagefeed {\n\t\twidth: 100%;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\n\t.landingContent {\n\t\tmargin-top: 20px;\n\t\tpadding: 0;\n\t}\n\n\t.landingContentTitle {\n\t\tfont-size: 20px;\n\t}\n\n\t.calenderColorText,\n\t.bookedWidth {\n\t\tfont-size: 14px !important;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.caListPara {\n\t\tfloat: left;\n\t\twidth: 70%;\n\t\tpadding: 0 0 0 10px;\n\t}\n\n\t.minMaxMobile {\n\t\tpadding: 25px 20px 170px;\n\t}\n\n\t.fullWidthCalendar {\n\t\tpadding: 0 15px;\n\t}\n\n\t.titleWidth {\n\t\tdisplay: none;\n\t}\n\n\t.stepGrid {\n\t\tbackground: unset;\n\t}\n\n}\n\n@media (min-width: 768px) and (max-width: 1199.98px) {\n\t.fullWidthCalendar {\n\t\tpadding: 0 30px;\n\t}\n}\n\n@media screen and (max-width: 340px) {\n\t.landingMainContent {\n\t\tpadding: 25px 20px 160px;\n\t}\n}","@import '../ListPlaceStep1/ListPlaceStep1.css';\n@import '../../components/utils.css';\n\n.saveCalendarContainer {\n    padding: 24px;\n    border: 1px solid var(--primary-border);\n    border-radius: 12px;\n}\n\n.selectedDatesBox {\n    padding: 7px 10px 10px;\n    font-size: 14px;\n    line-height: 24px;\n    color: rgb(72, 72, 72);\n    border: 1px solid var(--primary-border);\n    border-radius: 5px;\n    height: 43px;\n}\n\n.arrowIcon {\n    vertical-align: middle;\n    fill: rgb(72, 72, 72);\n    height: 24px;\n    width: 24px;\n    margin: 0px 12px;\n}\n\n.loaderContainer {\n    display: inline;\n    padding-right: 0px;\n}\n\n.landingContentTitle {\n    margin: 0px 0px 18px 0px;\n}\n\n.floatLeftInput {\n    float: left;\n}\n\n.inputHeight {\n    height: 48px;\n    box-shadow: inherit;\n    border: 1px solid var(--primary-border)\n}\n\n.aBlockWrap {\n    overflow: hidden;\n}\n\n.aBWLeft,\n.aBWRight {\n    width: 50%;\n    float: left;\n}\n\n.aBWLeft .btnBg {\n    border-radius: 6px 0 0 6px;\n}\n\n.aBWRight .btnBg {\n    border-radius: 0 6px 6px 0;\n}\n\n.aBlockWrap .btnBg {\n    width: 100%;\n    height: 48px;\n    border-color: var(--primary-border);\n    color: var(--btn-primary-bg);\n    font-size: 18px;\n}\n\n.aBlockWrap .btnBg:hover,\n.aBlockWrap .btnBg:active,\n.aBlockWrap .btnBg:focus,\n.aBlockWrap .btnBg.active {\n    background: var(--btn-primary-bg);\n    color: var(--white-text);\n}\n\n.textRight {\n    text-align: right;\n}\n\n.sDateWrap {\n    margin: 20px 0 10px;\n}\n\n.sDateWrap label {\n    margin: 0;\n}\n\n.marginBottom {\n    margin-bottom: 0;\n}\n\n\n@media (max-width: 1199.98px) {\n    .saveCalendarContainer {\n        padding: 20px 15px 45px;\n        margin-top: 50px;\n    }\n}\n\n@media (min-width:768px) and (max-width:991.98px) {\n    .sDateWrap {\n        margin: 20px 0 10px;\n    }\n\n    .sDateWrap h4 {\n        font-size: 14px;\n        margin: 0;\n    }\n}\n\n@media screen and (max-width: 767.98px) {\n    .saveCalendarContainer {\n        margin-top: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `SaveCalendar-errorMessage-gKG3f`,
	"space1": `SaveCalendar-space1-tD9QG`,
	"space2": `SaveCalendar-space2-EyXsY`,
	"space3": `SaveCalendar-space3-d4EYA`,
	"space4": `SaveCalendar-space4-z9fue`,
	"space5": `SaveCalendar-space5-l9CPK`,
	"space6": `SaveCalendar-space6-ulQEm`,
	"space7": `SaveCalendar-space7-tgDI9`,
	"space8": `SaveCalendar-space8-n6Ix3`,
	"spaceTop1": `SaveCalendar-spaceTop1-c9EzL`,
	"spaceTop2": `SaveCalendar-spaceTop2-cosGs`,
	"spaceTop3": `SaveCalendar-spaceTop3-n3jRv`,
	"spaceTop4": `SaveCalendar-spaceTop4-k0Qgg`,
	"spaceTop5": `SaveCalendar-spaceTop5-diYPC`,
	"spaceTop6": `SaveCalendar-spaceTop6-vWoAo`,
	"spaceTop7": `SaveCalendar-spaceTop7-xFwZW`,
	"spaceTop8": `SaveCalendar-spaceTop8-WpJKF`,
	"noMargin": `SaveCalendar-noMargin-y6Pe7`,
	"padding1": `SaveCalendar-padding1-H5qkr`,
	"padding2": `SaveCalendar-padding2-JIhcD`,
	"padding3": `SaveCalendar-padding3-w8VYr`,
	"padding4": `SaveCalendar-padding4-Cad9j`,
	"padding5": `SaveCalendar-padding5-fH28s`,
	"padding6": `SaveCalendar-padding6-vIgKg`,
	"padding7": `SaveCalendar-padding7-pGled`,
	"paddingTop1": `SaveCalendar-paddingTop1-oAaEI`,
	"paddingTop2": `SaveCalendar-paddingTop2-hqyKk`,
	"paddingTop3": `SaveCalendar-paddingTop3-M6Pqm`,
	"paddingTop4": `SaveCalendar-paddingTop4-CvtpU`,
	"paddingTop5": `SaveCalendar-paddingTop5-tR2fT`,
	"paddingTop6": `SaveCalendar-paddingTop6-FbF5b`,
	"paddingTop7": `SaveCalendar-paddingTop7-B2RWU`,
	"noPadding": `SaveCalendar-noPadding-nt7Pt`,
	"spaceMarginBottom0": `SaveCalendar-spaceMarginBottom0-YZ0Mw`,
	"textBold": `SaveCalendar-textBold-Pdw2_`,
	"textBolder": `SaveCalendar-textBolder-N1aIw`,
	"textNormal": `SaveCalendar-textNormal-TB4OB`,
	"textDarkBlue": `SaveCalendar-textDarkBlue-mcQhN`,
	"textLightBlue": `SaveCalendar-textLightBlue-ZFVM8`,
	"textLightSandleGreen": `SaveCalendar-textLightSandleGreen-mjtY4`,
	"textLightBrown": `SaveCalendar-textLightBrown-AoxRY`,
	"textMediumMaroon": `SaveCalendar-textMediumMaroon-F8zRS`,
	"textBrown": `SaveCalendar-textBrown-A4_v4`,
	"textMaroon": `SaveCalendar-textMaroon-ifcnX`,
	"textDarkBrown": `SaveCalendar-textDarkBrown-PxfPQ`,
	"textMediumBrown": `SaveCalendar-textMediumBrown-_CZB1`,
	"textSkyBlue": `SaveCalendar-textSkyBlue-Mu6P8`,
	"textGray": `SaveCalendar-textGray-qsq4b`,
	"btn": `SaveCalendar-btn-cqi6K`,
	"btnPrimary": `SaveCalendar-btnPrimary-k8x4j`,
	"btnPrimaryBorder": `SaveCalendar-btnPrimaryBorder-g29N9`,
	"btnSecondary": `SaveCalendar-btnSecondary-t8jqD`,
	"btnLink": `SaveCalendar-btnLink-cFIw7`,
	"btnLinkPrimary": `SaveCalendar-btnLinkPrimary-lVbQz`,
	"btnLinkSecondary": `SaveCalendar-btnLinkSecondary-pYepx`,
	"searchFilterPopover": `SaveCalendar-searchFilterPopover-j3pmK`,
	"searchFilterPopoverFull": `SaveCalendar-searchFilterPopoverFull-fPaFk`,
	"searchFilterPopoverOverlay": `SaveCalendar-searchFilterPopoverOverlay-MPDLu`,
	"searchFilterPopoverContent": `SaveCalendar-searchFilterPopoverContent-JsM3K`,
	"searchFilterCloseIcon": `SaveCalendar-searchFilterCloseIcon-cTbpt`,
	"searchFilterPopoverFooter": `SaveCalendar-searchFilterPopoverFooter-cnsMZ`,
	"displayTable": `SaveCalendar-displayTable-eb_7w`,
	"displayTableRow": `SaveCalendar-displayTableRow-OZ814`,
	"displayTableCell": `SaveCalendar-displayTableCell-GjAwt`,
	"displayInlineBlock": `SaveCalendar-displayInlineBlock-zVEk8`,
	"fullWidth": `SaveCalendar-fullWidth-M6bA1`,
	"captionTitle": `SaveCalendar-captionTitle-xdCdZ`,
	"showTabletSection": `SaveCalendar-showTabletSection-tfOMJ`,
	"incrementDecrementButton": `SaveCalendar-incrementDecrementButton-H0MyY`,
	"commonBorder": `SaveCalendar-commonBorder-PSdfC`,
	"textCenter": `SaveCalendar-textCenter-n3Xxm`,
	"searchFilterPopoverHeader": `SaveCalendar-searchFilterPopoverHeader-u94kx`,
	"textSize": `SaveCalendar-textSize-ZkM1a`,
	"capitalizeText": `SaveCalendar-capitalizeText-jXI3D`,
	"hideBothTabletAndMobile": `SaveCalendar-hideBothTabletAndMobile-Zok61`,
	"btnFontsize": `SaveCalendar-btnFontsize-W0Rzv`,
	"transmissionBottom": `SaveCalendar-transmissionBottom-sNw1c`,
	"marginTop20": `SaveCalendar-marginTop20-JGExM`,
	"marginRight15": `SaveCalendar-marginRight15-eUgcW`,
	"marginNone": `SaveCalendar-marginNone-x2C2d`,
	"paddingNone": `SaveCalendar-paddingNone-kXjmV`,
	"infoPadding": `SaveCalendar-infoPadding-eJmKp`,
	"pullRight": `SaveCalendar-pullRight-sB9Sl`,
	"displayFlex": `SaveCalendar-displayFlex-VzfeP`,
	"hideTabletSection": `SaveCalendar-hideTabletSection-_dqtz`,
	"applyBtnDesktop": `SaveCalendar-applyBtnDesktop-tZW_o`,
	"applyBtn": `SaveCalendar-applyBtn-U4bIe`,
	"applyBtnDesktopRight": `SaveCalendar-applyBtnDesktopRight-IOKc6`,
	"applyBtnDesktopNoPaddingRight": `SaveCalendar-applyBtnDesktopNoPaddingRight-kNZxE`,
	"activeItem": `SaveCalendar-activeItem-LyaI4`,
	"activeSection": `SaveCalendar-activeSection-s3cCu`,
	"currencyAndLangGrid": `SaveCalendar-currencyAndLangGrid-ZZkKo`,
	"btnSmall": `SaveCalendar-btnSmall-c0BGX`,
	"formGroup": `SaveCalendar-formGroup-tkqSn`,
	"jumboInput": `SaveCalendar-jumboInput-TOnxx`,
	"formControlSelect": `SaveCalendar-formControlSelect-ERpb5`,
	"formControlSelectLarge": `SaveCalendar-formControlSelectLarge-msXQI`,
	"select": `SaveCalendar-select-Vnfiy`,
	"landingContainer": `SaveCalendar-landingContainer-autrm`,
	"landingTitle": `SaveCalendar-landingTitle-kXPXZ`,
	"landingStep": `SaveCalendar-landingStep-TVbfs`,
	"landingStep2": `SaveCalendar-landingStep2-oVtJx`,
	"landingStep3": `SaveCalendar-landingStep3-ia8O6`,
	"landingContentTitle": `SaveCalendar-landingContentTitle-_mwTX`,
	"landingContent": `SaveCalendar-landingContent-I0AiT`,
	"landingMainContent": `SaveCalendar-landingMainContent-vJsat`,
	"landingLabel": `SaveCalendar-landingLabel-W9uOO`,
	"bookingTitle": `SaveCalendar-bookingTitle-oaAAA`,
	"bookText": `SaveCalendar-bookText-hja0z`,
	"radioInput": `SaveCalendar-radioInput-hNQmy`,
	"radioSize": `SaveCalendar-radioSize-HwcKn`,
	"checkboxLabel": `SaveCalendar-checkboxLabel-mLPg5`,
	"landingCaption": `SaveCalendar-landingCaption-Fa2Kl`,
	"listContainer": `SaveCalendar-listContainer-J9Qgw`,
	"listContent": `SaveCalendar-listContent-ITJHT`,
	"horizontalLineThrough": `SaveCalendar-horizontalLineThrough-XEEJW`,
	"helpPanelContainer": `SaveCalendar-helpPanelContainer-bWkJM`,
	"helpPanel": `SaveCalendar-helpPanel-C3WL1`,
	"helpPanelText": `SaveCalendar-helpPanelText-dKIaH`,
	"helpPanelTextTitle": `SaveCalendar-helpPanelTextTitle-LYDgS`,
	"incrementDecrementText": `SaveCalendar-incrementDecrementText-VpMxG`,
	"iconButton": `SaveCalendar-iconButton-LDa5F`,
	"checkBoxSection": `SaveCalendar-checkBoxSection-SlS_9`,
	"checkBoxLabel": `SaveCalendar-checkBoxLabel-Qh_9K`,
	"textAlignRight": `SaveCalendar-textAlignRight-vayZQ`,
	"textAlignLeft": `SaveCalendar-textAlignLeft-PBOq0`,
	"textAlignCenter": `SaveCalendar-textAlignCenter-VH_vs`,
	"pullLeft": `SaveCalendar-pullLeft-kbRmH`,
	"unorderedList": `SaveCalendar-unorderedList-wgMv_`,
	"checkIcon": `SaveCalendar-checkIcon-NWwyk`,
	"textHigh": `SaveCalendar-textHigh-PhyNU`,
	"textLow": `SaveCalendar-textLow-vNGDw`,
	"listPhotoCover": `SaveCalendar-listPhotoCover-uJ1tw`,
	"listPhotoMedia": `SaveCalendar-listPhotoMedia-t8sGw`,
	"imgResponsive": `SaveCalendar-imgResponsive-QgUuo`,
	"coverPhotoSelection": `SaveCalendar-coverPhotoSelection-KBkds`,
	"coverPhotoCheckbox": `SaveCalendar-coverPhotoCheckbox-vc8JZ`,
	"landingSaftyTitle": `SaveCalendar-landingSaftyTitle-RA4gQ`,
	"bookingLandingStep": `SaveCalendar-bookingLandingStep-GJ76s`,
	"BookingradioInput": `SaveCalendar-BookingradioInput-L0Lf0`,
	"subText": `SaveCalendar-subText-tz5w8`,
	"landingText": `SaveCalendar-landingText-dRGWc`,
	"listType": `SaveCalendar-listType-D3HVJ`,
	"iconContainer": `SaveCalendar-iconContainer-vzFiT`,
	"iconSize": `SaveCalendar-iconSize-jxfut`,
	"calenderText": `SaveCalendar-calenderText-j8o6u`,
	"LineColor": `SaveCalendar-LineColor-jQwgJ`,
	"btnContainer": `SaveCalendar-btnContainer-_nvcV`,
	"displayTableCellVertical": `SaveCalendar-displayTableCellVertical-yBViW`,
	"paddingLeft": `SaveCalendar-paddingLeft-njBEy`,
	"iconColor": `SaveCalendar-iconColor-ZXS9N`,
	"space0": `SaveCalendar-space0-M4krK`,
	"step3IconLeft": `SaveCalendar-step3IconLeft-cCsy5`,
	"displayTableCellWidth": `SaveCalendar-displayTableCellWidth-oAJm7`,
	"displayTableCellTop": `SaveCalendar-displayTableCellTop-Yw1o_`,
	"tableWidth": `SaveCalendar-tableWidth-SdQx5`,
	"noFontWeight": `SaveCalendar-noFontWeight-MngMG`,
	"nextPosition": `SaveCalendar-nextPosition-C_QZw`,
	"nextBackButtonCalendar": `SaveCalendar-nextBackButtonCalendar-ubKUE`,
	"posRelative": `SaveCalendar-posRelative-cm2dK`,
	"imagefeed": `SaveCalendar-imagefeed-OQqoe`,
	"caListimg": `SaveCalendar-caListimg-q_Ec2`,
	"caListPara": `SaveCalendar-caListPara-QShaf`,
	"marginLeft5": `SaveCalendar-marginLeft5-f89Yg`,
	"notAvailableColor": `SaveCalendar-notAvailableColor-UV_U8`,
	"bookedColor": `SaveCalendar-bookedColor-Yfth2`,
	"availableColor": `SaveCalendar-availableColor-Ij9UR`,
	"specialColor": `SaveCalendar-specialColor-nyCKb`,
	"noMarginMaximum": `SaveCalendar-noMarginMaximum-Ax0Qy`,
	"maximumSpace2": `SaveCalendar-maximumSpace2-IPYg3`,
	"maximumCharcter": `SaveCalendar-maximumCharcter-N3u6W`,
	"maximumCharColor": `SaveCalendar-maximumCharColor-wGzhX`,
	"requiredMessage": `SaveCalendar-requiredMessage-GIiPY`,
	"infoIconCss": `SaveCalendar-infoIconCss-gZJok`,
	"deliveryInfo": `SaveCalendar-deliveryInfo-PJ1ay`,
	"stepGrid": `SaveCalendar-stepGrid-VbYFs`,
	"stepSizeCss": `SaveCalendar-stepSizeCss-FQdYE`,
	"nextBackButton": `SaveCalendar-nextBackButton-d973p`,
	"leftBg": `SaveCalendar-leftBg-am4ic`,
	"titleWidth": `SaveCalendar-titleWidth-aB_KB`,
	"stepFooterImage": `SaveCalendar-stepFooterImage-CGxn4`,
	"saveColor": `SaveCalendar-saveColor-fUbwF`,
	"searchToolTip": `SaveCalendar-searchToolTip-JrFZ6`,
	"locationTipCss": `SaveCalendar-locationTipCss-CZNL3`,
	"fullWidthCalendar": `SaveCalendar-fullWidthCalendar-vyqH7`,
	"checkBoxLeft": `SaveCalendar-checkBoxLeft-qqkdR`,
	"checkBoxFlex": `SaveCalendar-checkBoxFlex-TK2zp`,
	"alignBase": `SaveCalendar-alignBase-WDNra`,
	"reviewGuestFlex": `SaveCalendar-reviewGuestFlex-kmOMK`,
	"becomeAHostSelect": `SaveCalendar-becomeAHostSelect-r6R_X`,
	"calenderColorText": `SaveCalendar-calenderColorText-U6Ofo`,
	"bookedWidth": `SaveCalendar-bookedWidth-tW5s2`,
	"userRight": `SaveCalendar-userRight-fYwoj`,
	"sayCss": `SaveCalendar-sayCss-jx_R5`,
	"listIntroBgSection": `SaveCalendar-listIntroBgSection-nypci`,
	"footerImageOnboard": `SaveCalendar-footerImageOnboard-ZQmj9`,
	"footerFullWidth": `SaveCalendar-footerFullWidth-NLkpn`,
	"bulbIcon": `SaveCalendar-bulbIcon-wB10u`,
	"brandImg": `SaveCalendar-brandImg-QAdyE`,
	"stepLogo": `SaveCalendar-stepLogo-eIX8H`,
	"syncCalendarBtn": `SaveCalendar-syncCalendarBtn-yLgEu`,
	"locationOverflowHidden": `SaveCalendar-locationOverflowHidden-vMvL4`,
	"button": `SaveCalendar-button-_yUqu`,
	"minMaxMobile": `SaveCalendar-minMaxMobile-WgrjS`,
	"saveCalendarContainer": `SaveCalendar-saveCalendarContainer-v56T7`,
	"selectedDatesBox": `SaveCalendar-selectedDatesBox-IKWqH`,
	"arrowIcon": `SaveCalendar-arrowIcon-ZDjjV`,
	"loaderContainer": `SaveCalendar-loaderContainer-vwjTm`,
	"floatLeftInput": `SaveCalendar-floatLeftInput-ndwC0`,
	"inputHeight": `SaveCalendar-inputHeight-ZrRFn`,
	"aBlockWrap": `SaveCalendar-aBlockWrap-cVIxa`,
	"aBWLeft": `SaveCalendar-aBWLeft-JGPGA`,
	"aBWRight": `SaveCalendar-aBWRight-K41WC`,
	"btnBg": `SaveCalendar-btnBg-tFuHN`,
	"active": `SaveCalendar-active-yl9G3`,
	"textRight": `SaveCalendar-textRight-v_L7Y`,
	"sDateWrap": `SaveCalendar-sDateWrap-MMNuc`,
	"marginBottom": `SaveCalendar-marginBottom-zSkzt`
};
module.exports = ___CSS_LOADER_EXPORT___;
